(ns story-builder.debug
  (:require [cljs.pprint :refer [pprint]]
            [clojure.spec.alpha :as s]
            [re-frame.core :as rf]
            [story-builder.define :as define]
            [story-builder.spec.story :as spec.story]
            [story-builder.util.core :as util]))

;; Customize this function as you need (but do not commit it).
(defn- log-event? [[event-type & event-params]]
  true)

;; Customize this function as you need (but do not commit it).
(defn- ignore-event? [[event-type & event-params]]
  (#{:stories/on-edit-ping} event-type))

(def ^:private event-logger-interceptor
  (rf/->interceptor
   :id    :event-logger
   :after (fn [context]
            (let [{:keys [coeffects effects]} context
                  {:keys [event]} coeffects
                  {:keys [dispatch dispatch-n]} effects]
              (when (and (log-event? event)
                         (not (ignore-event? event)))
                (pprint (cond-> {:event event}
                          (some? dispatch) (assoc :dispatch dispatch)
                          (some? dispatch-n) (assoc :dispatch-n dispatch-n)))))
            context)))

(when define/log-reframe-events?
  (rf/reg-global-interceptor event-logger-interceptor))

;; *********************************************
;;   Gathering of recent events for debugging
;; *********************************************

(defonce recent-event-queue (atom #queue []))
(def recent-event-queue-max-size 200)

(def events-too-frequent-with-low-corruption-risk
  #{:auth/tokens!
    :on-refresh-token
    :stories/can-edit?
    :stories/on-edit-ping
    :make-request
    :ui/loading
    :components/collapse-height})

(defn recent-events-summary []
  (let [filtered-events (->> @recent-event-queue
                             ;; Filter out the frequent events which have a low probability of corrupting the story
                             (remove (comp events-too-frequent-with-low-corruption-risk first))
                             ;; We want to the latest events to be shown first.
                             reverse)]
    (-> []
        ;; Take the latest 10 events
        (into (->> filtered-events
                   (take 10)))
        ;; Take only the keyword from the next events
        (into (->> filtered-events
                   (drop 10)
                   (map first))))))

(comment
  ;; The current ranking of dispatched event's types
  (->> @recent-event-queue
       (mapv first)
       (frequencies)
       (sort-by second >)))

(def ^:private recent-events-interceptor
  (rf/->interceptor
   :id     :recent-events
   :before (fn [context]
             (swap! recent-event-queue
                    (fn [queue]
                      (let [event (-> context :coeffects :event)
                            queue (conj queue event)]
                        (cond-> queue
                          (> (count queue) recent-event-queue-max-size) pop))))
             context)))

(rf/reg-global-interceptor recent-events-interceptor)

#_(defn- periodic-story-config-validation-interceptor
    "Validates the story-config once every `n-events` when it is present in the re-frame db."
    [n-events]
    (let [event-counter (atom 0)]
      (rf/->interceptor
       :id     :periodic-story-validator
       :before (fn [context]
                 (when (events-too-frequent-with-low-corruption-risk (-> context :coeffects :event first))
                   (swap! event-counter (fn [n] (mod (inc n) n-events)))
                   (when (zero? @event-counter)
                     (when-some [story-config (-> context :coeffects :db :persistent :story :story-config)]
                        ;;(prn [:story-config story-config])
                       (when-not (s/valid? ::spec.story/story story-config)
                         (util/exception (pr-str (::s/problems (s/explain-data ::spec.story/story story-config))
                                                 (recent-events-summary)
                                                 story-config))))))

                 context))))

;; Validates the story once every 10 events.
#_(rf/reg-global-interceptor (periodic-story-config-validation-interceptor 10))
